import { render, staticRenderFns } from "./StextareaPreview.vue?vue&type=template&id=22daf75d&"
import script from "./StextareaPreview.vue?vue&type=script&lang=js&"
export * from "./StextareaPreview.vue?vue&type=script&lang=js&"
import style0 from "./StextareaPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports